import { ReactComponent as mylocation } from "../assets/icons/myLocation.svg";
import genIcons from "./genIcons";

const MyLocation = {
  Outline: genIcons(mylocation),
};

export default MyLocation;